import type { EntitiesState } from '@redux/entities'

type FindAgencyProviderParams = {
  agencyId: number,
  agencyProviders: EntitiesState['agencyProviders'],
  providerId: number,
  serviceId: number,
}

function findAgencyProvider(params: FindAgencyProviderParams) {
  const {
    agencyProviders, agencyId, serviceId, providerId,
  } = params

  const array = Object.values(agencyProviders)
  const match = array.find(
    agencyProvider => agencyProvider.agency_id === agencyId
      && agencyProvider.service_id === serviceId
      && agencyProvider.provider_id === providerId,
  )

  return match || {}
}

export default findAgencyProvider
